(function () {
  'use strict';

  var STORAGE_KEY = 'qaara_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage unavailable (private mode, etc.) — fail silently */
    }
  }

  function isWishlisted(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    var added;
    if (idx === -1) {
      list.push(handle);
      added = true;
    } else {
      list.splice(idx, 1);
      added = false;
    }
    saveWishlist(list);
    updateCountBadges();
    document.dispatchEvent(
      new CustomEvent('qaara:wishlist:change', { detail: { handle: handle, added: added, list: list } })
    );
    return added;
  }

  function updateCountBadges() {
    var count = getWishlist().length;
    var badges = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
      badges[i].setAttribute('data-count', count);
      if (count > 0) {
        badges[i].classList.add('has-items');
      } else {
        badges[i].classList.remove('has-items');
      }
    }
  }

  function updateButtonStates() {
    var list = getWishlist();
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var handle = btn.getAttribute('data-product-handle');
      var active = list.indexOf(handle) !== -1;
      btn.classList.toggle('is-wishlisted', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var labelEl = btn.querySelector('[data-wishlist-label]');
      if (labelEl) {
        var addLabel = btn.getAttribute('data-label-add') || 'Add to Wishlist';
        var removeLabel = btn.getAttribute('data-label-remove') || 'Remove from Wishlist';
        labelEl.textContent = active ? removeLabel : addLabel;
      }
    }
  }

  function handleClick(e) {
    var btn = e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    toggleWishlist(handle);
    updateButtonStates();
  }

  document.addEventListener('click', handleClick);

  document.addEventListener('qaara:wishlist:change', function () {
    if (document.querySelector('[data-wishlist-grid]')) {
      renderWishlistPage();
    }
  });

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function formatMoney(cents) {
    var format = window.qaaraMoneyFormat || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    if (!match) return '$' + (cents / 100).toFixed(2);

    function withDelimiters(number, precision, thousands, decimalSep) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimalSep = typeof decimalSep === 'undefined' ? '.' : decimalSep;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var decimals = parts[1] ? decimalSep + parts[1] : '';
      return dollars + decimals;
    }

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  function buildCard(product, handle) {
    var card = document.createElement('div');
    card.className = 'qaara-wishlist__card';
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var imgSrc = img ? img + (img.indexOf('?') === -1 ? '?width=600' : '&width=600') : '';
    card.innerHTML =
      '<a href="/products/' + handle + '" class="qaara-wishlist__card-image">' +
        (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '') +
      '</a>' +
      '<div class="qaara-wishlist__card-info">' +
        '<a href="/products/' + handle + '" class="qaara-wishlist__card-title">' + escapeHtml(product.title) + '</a>' +
        '<div class="qaara-wishlist__card-price">' + formatMoney(product.price) + '</div>' +
        '<button type="button" class="qaara-wishlist__card-remove" data-wishlist-toggle data-product-handle="' + handle + '">Remove</button>' +
      '</div>';
    return card;
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var list = getWishlist();
    var emptyState = document.querySelector('[data-wishlist-empty]');

    if (!list.length) {
      grid.innerHTML = '';
      if (emptyState) emptyState.style.display = '';
      return;
    }
    if (emptyState) emptyState.style.display = 'none';
    grid.innerHTML = '<div class="qaara-wishlist__loading">Loading your wishlist…</div>';

    Promise.all(
      list.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      grid.innerHTML = '';
      var any = false;
      products.forEach(function (product, i) {
        if (!product) return;
        any = true;
        grid.appendChild(buildCard(product, list[i]));
      });
      if (!any && emptyState) {
        emptyState.style.display = '';
      }
    });
  }

  function init() {
    updateCountBadges();
    updateButtonStates();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.QaaraWishlist = {
    get: getWishlist,
    has: isWishlisted,
    toggle: toggleWishlist,
    count: function () {
      return getWishlist().length;
    },
    refresh: function () {
      updateCountBadges();
      updateButtonStates();
    }
  };
})();
